import {useMessages} from "i18n";
import Seo from "../seo/Seo";
import {AboutPageRoot} from "../about/AboutPage";

/** Public, pre-rendered About page. */
export function Component() {
	const {seo} = useMessages();
	return (
		<>
			<Seo
				title={seo.about.title}
				description={seo.about.description}
				path="/about"
			/>
			<AboutPageRoot/>
		</>
	);
}
